import { TestSegmentService, JsonApiProcessor } from '../../../data/services'
import { TestSegment } from '../../../data/models'
import { IOperationServiceConfig } from '../../../model-repository'

export const TestSegmentConfig: IOperationServiceConfig<TestSegment> = {
  service: TestSegmentService,
  deps: [JsonApiProcessor],
  endpoint: 'exams/test_segments',
  model: TestSegment
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/operation/test-segment.config.ts